import { createContext, useContext, useMemo } from "react";
import PropTypes from "prop-types";

const ProductContext = createContext(null);

export const ProductContextProvider = ({ products, productId, children }) => {
  const product = useMemo(() => {
    if (!products?.length || !productId) {
      return null;
    }

    return products.find(({ id }) => id === productId) || null;
  }, [products, productId]);

  const value = useMemo(() => ({ product }), [product]);

  return (
    <ProductContext.Provider value={value}>{children}</ProductContext.Provider>
  );
};

ProductContextProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  products: PropTypes.array,
  productId: PropTypes.number,
};

export const useProduct = () => useContext(ProductContext);
